import dayjs from "dayjs";
import type { VehicleUsageDto } from "@/lib/api";
import type { ActiveVehicleUsage } from "../../types/vehicle-usage.types";

export function toActiveVehicleUsage(
	dto: VehicleUsageDto | null | undefined
): ActiveVehicleUsage | null {
	if (!dto?.vehicleUsage) return null;

	const { vehicleUsage } = dto;
	const end = vehicleUsage.period?.end;
	const isOverdue = !!end && dayjs(end).isBefore(dayjs());

	return {
		id: vehicleUsage.id,
		bookingId: vehicleUsage.bookingId,
		period: vehicleUsage.period
			? {
					start: vehicleUsage.period.start,
					end: vehicleUsage.period.end,
					timeZone: vehicleUsage.period.timeZone,
				}
			: undefined,
		status: vehicleUsage.status,
		statusMessage: vehicleUsage.statusMessage,
		mileageStartValue: dto.mileageStartValue,
		mileageEndValue: dto.mileageEndValue,
		mileageDelta: dto.mileageDelta,
		isOverdue,
	};
}
